// src/components/pwa/InstallBanner.tsx
import React from 'react';
import { Button, Icon, IconButton } from '../common';
import { usePWA } from '../../contexts/pwa-hooks';

/**
 * Top-of-viewport install prompt banner.
 * One-time — permanently dismissable via localStorage.
 * Only renders in Chromium browsers when the app meets PWA install criteria.
 */
export const InstallBanner: React.FC = () => {
    const { canInstall, installDismissed, installApp, dismissInstallBanner } = usePWA();

    if (!canInstall || installDismissed) return null;

    return (
        <div
            id="pwa-install-banner"
            className="fixed top-0 left-0 right-0 z-60 flex items-center justify-center gap-3
                px-4 py-2 bg-gray-900 dark:bg-gray-800 text-white border-b border-amber-500/30
                print:hidden"
        >
            <Icon name="install_mobile" className="text-amber-400 text-lg" />
            <p className="text-sm font-medium">
                Get the full experience — <span className="text-amber-400">Install On Book Pro</span>
            </p>
            <Button
                variant="primary"
                size="sm"
                onClick={installApp}
                className="min-h-0 px-3 py-1 text-xs font-bold uppercase tracking-wide
                    bg-amber-500 text-gray-900 shadow-none hover:bg-amber-400"
            >
                Install
            </Button>
            <IconButton
                icon="close"
                label="Dismiss install banner"
                onClick={dismissInstallBanner}
                className="ml-auto flex min-h-[44px] min-w-[44px] items-center justify-center rounded-full text-white hover:bg-white/10 hover:text-white"
            />
        </div>
    );
};
